import '@lauragaistourisme/js/lib/storymap';

export default class Roadtrip {

	constructor() {
		Roadtrip.story_map();
	}

	static story_map() {

		const roadTripBlock = $('[data-id="road-trip-block"]');

		roadTripBlock.each(function () {
			const block = $(this),
				roadTripList = block.find('[data-id="road-trip-list"]'),
				roadTripMap = block.find('[data-id="road-trip-map"]'),
				roadTripMapContainer = block.find('[data-id="road-trip-map-container"]'),
				markers = [],
				kml = roadTripMap.attr('data-kml');

			block.find('[data-id="road-trip-step"]').each(function (index) {

				let poi = [];
				$(this).find('[data-id="wpiris-interest-points-item"]').each(function (i) {
					const latitude = $(this).attr('data-latitude');
					const longitude = $(this).attr('data-longitude');
					const id = $(this).attr('id');

					if (latitude != '' && longitude != '' && latitude != undefined && longitude != undefined) {
						poi[i] = {
							lat: latitude,
							long: longitude,
							id: id,
						}
					}
				});

				markers[index + 1] = {
					name: $(this).data('place'),
					lat: $(this).data('latitude'),
					long: $(this).data('longitude'),
					step: $(this).data('step'),
					zoom: $(this).data('zoom'),
					bearing: $(this).data('bearing'),
					pitch: $(this).data('pitch'),
					poi: poi,
				}
			});

			if (roadTripList.length > 0) {
				roadTripList.storymap({
					markers: markers,
					kml: kml,
					id: roadTripMap.attr('id'),
					current_block: block,
				});
			}
		});
	}
}
